import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";
import { Backdrop, Title, Kicker } from "../components";
import { COLORS, FONT, SAFE } from "../theme";

// Autos dispersos con "?" que se desvanecen para dar paso a la solución.
const cars = [
  { x: 240, y: 250, d: 0 },
  { x: 1450, y: 200, d: 6 },
  { x: 300, y: 760, d: 10 },
  { x: 1520, y: 720, d: 3 },
  { x: 880, y: 150, d: 14 },
  { x: 1180, y: 880, d: 8 },
];

const CarGhost: React.FC<{ x: number; y: number; d: number }> = ({ x, y, d }) => {
  const frame = useCurrentFrame();
  const op = interpolate(frame, [d, d + 18, 70, 92], [0, 0.5, 0.5, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const float = Math.sin((frame + d * 8) / 22) * 8;
  return (
    <div
      style={{
        position: "absolute",
        left: x,
        top: y,
        opacity: op,
        translate: `0px ${float}px`,
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      <svg width="86" height="86" viewBox="0 0 24 24" fill="none">
        <path
          d="M5 11l1.5-4A2 2 0 0 1 8.4 5.7h7.2a2 2 0 0 1 1.9 1.3L19 11m-14 0h14m-14 0a2 2 0 0 0-2 2v3h2m14-5a2 2 0 0 1 2 2v3h-2M6 16h12M7 16v1.5M17 16v1.5"
          stroke={COLORS.sub}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span
        style={{
          fontFamily: FONT,
          fontWeight: 800,
          fontSize: 54,
          color: COLORS.amber,
        }}
      >
        ?
      </span>
    </div>
  );
};

export const S2Problem: React.FC = () => {
  return (
    <AbsoluteFill>
      <Backdrop tint="blue" />
      {cars.map((c, i) => (
        <CarGhost key={i} {...c} />
      ))}
      <AbsoluteFill
        style={{
          justifyContent: "center",
          alignItems: "center",
          padding: SAFE,
          textAlign: "center",
        }}
      >
        <div style={{ marginBottom: 30 }}>
          <Kicker color={COLORS.amber}>El problema</Kicker>
        </div>
        <Title size={104} maxWidth={1550} delay={4}>
          ¿Dónde está cada vehículo de tu flota, ahora mismo?
        </Title>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};
